import { mutationOptions } from '@tanstack/react-query';
import { CONTACT_QUERY_KEYS } from './keys';
import { contactAPIClient } from '../contactAPIClient';
import type { SubmitContactRequest } from './types';

export const CONTACT_QUERIES = {
  submit: () =>
    mutationOptions({
      mutationFn: (payload: SubmitContactRequest) => contactAPIClient.submitContact(payload),
      mutationKey: CONTACT_QUERY_KEYS.submit(),
    }),
};
